const tokenExpirationModalCopy = {
  buttonTextLogIn: 'Continue',
  buttonTextLogOut: 'Log Out',
  timeoutText1: 'Your session is about to expire due to inactivity.',
  timeoutText2: `If you'd like to remain in this session, please click "Continue" to remain logged in.`,
  title: 'Session Timeout'
};

export default tokenExpirationModalCopy;
